import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const masterValuationFieldsAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'masterValuationFieldsAPI',
    endpoints: (builder) => ({
        addMasterValuationFields: builder.mutation({
            query: (data) => ({
                url: `/MasterValuationFields/AddMasterValuationFields`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getMasterValuationFields: builder.mutation({
            query: (data) => ({
                url: `/MasterValuationFields/GetMasterValuationFields`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteMasterValuationFields: builder.mutation({
            query: (ValFieldID) => ({
                url: `/MasterValuationFields/DeleteMasterValuationFields?ValFieldID=${ValFieldID}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateMasterValuationFields: builder.mutation({
            query: (data) => ({
                url: `/MasterValuationFields/UpdateMasterValuationFields`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllMasterFieldCategories: builder.mutation({
            query: (data) => ({
                url: `/MasterValuationFields/GetAllMasterFieldCategories`,
                method: `GET`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllMasterValuationCopy: builder.mutation({
            query: (data) => ({
                url: `/MasterValuationFields/GetAllMasterValuationCopy`,
                method: `GET`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllOrigin: builder.mutation({
            query: (data) => ({
                url: `/MasterValuationFields/GetAllOrigin`,
                method: `GET`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllFormulaList: builder.mutation({
            query: (data) => ({
                url: `/MasterValuationFields/GetAllFormulaList`,
                method: `GET`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    })
})

export const { 
    useAddMasterValuationFieldsMutation,
    useGetMasterValuationFieldsMutation,
    useDeleteMasterValuationFieldsMutation,
    useUpdateMasterValuationFieldsMutation,
    useGetAllMasterFieldCategoriesMutation,
    useGetAllMasterValuationCopyMutation,
    useGetAllOriginMutation,
    useGetAllFormulaListMutation
  } = masterValuationFieldsAPI;
    export default masterValuationFieldsAPI